import gql from 'graphql-tag';

export const investigationMetricsDeterminationConnection = gql`query InvestigationMetricsDeterminationConnection($filters: [InvestigationMetricsFilter], $orderBy: InvestigationMetricsOrderBy, $first: Int, $last: Int, $before: ID, $after: ID, $sortOrder: SortOrder) {
  investigationMetricsDeterminationConnection(first: $first, last: $last, before: $before, after: $after, filters: $filters, orderBy: $orderBy, sortOrder: $sortOrder) {
    pageInfo {
      limit
      offset
      __typename
    }
    totalCount
    edges {
      cursor
      node {
        determination
        data
      }
      __typename
    }
    __typename
  }
}`

